import React, { useEffect } from "react";
import "../styles/snowfall.css";

export default function Snowfall() {
    useEffect(() => {
        const createSnowflake = () => {
            const snowflake = document.createElement("div");
            snowflake.className = "snowflake";
            //snowflake.textContent = "❄";
            //snowflake.textContent = "💧";
            //snowflake.textContent = "🔔";
            //snowflake.textContent = "🎄";

            // Random horizontal position
            snowflake.style.left = Math.random() * window.innerWidth + "px";

            // Random size
            const size = 10 + Math.random() * 20;
            snowflake.style.fontSize = size + "px";

            // Random fall duration
            const duration = 4 + Math.random() * 1
            snowflake.style.animationDuration = duration + "s";

            document.body.appendChild(snowflake);

            // Remove when animation ends
            snowflake.addEventListener("animationend", () => {
                snowflake.remove();
            });
        };

        const interval = setInterval(() => {
            for (let i = 0; i < 3; i++) createSnowflake();
        }, 300);

        // Stop after 3 seconds (change to any duration you want)
        const stopTimer = setTimeout(() => { clearInterval(interval); }, 5000);

        return () => clearInterval(interval);
    }, []);

    return null; // This component renders nothing visible
}
